import type { SlotType } from '@triveelo/ads-core';
import type { IconName } from './Icon';

export const SLOT_ICON: Record<SlotType, IconName> = {
  billboard: 'billboard',
  sign: 'sign',
  vehicle_wrap: 'bus',
  radio_jingle: 'radio',
  artist_spot: 'music',
  shoutout: 'message',
  sponsored_mission: 'star',
  music_player_spot: 'music',
  median_banner: 'sign',
  median_wall: 'billboard',
  perimeter_hoarding: 'billboard',
  wall_ad: 'sign',
};
